import {useEffect} from "react";
import {getId} from "../../helpers/file";

const doMonitor = () => {
  const uid = getId() as string;
  fetch('/img/monitor', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=utf8'
    },
    body: JSON.stringify({
      uid
    }),
  });
}

const Monitor = () => {

  useEffect(() => {
    console.info('monitor start');
    doMonitor();

    const timer = setInterval(() => {
      doMonitor();
    }, 1000 * 10);

    return () => {
      clearInterval(timer);
    }
  }, []);

  return <span></span>;
}

export default Monitor